import { isMacOS } from "./ua-utils";

function getAltKeyShortcut(shortcutKey: string | number) {
    const prefix = isMacOS() ? "⌥" : "Alt+";
    return `${prefix}${shortcutKey}`;
}

function getCmdKeyShortcut(shortcutKey: string | number) {
    const prefix = isMacOS() ? "⌘" : "Ctrl+";
    return `${prefix}${shortcutKey}`;
}

function getCmdAltKeyShortcut(shortcutKey: string | number): string {
    const prefix = isMacOS() ? "⌘⌥" : "Ctrl+Alt+";
    return `${prefix}${shortcutKey}`;
}

export {
    getAltKeyShortcut,
    getCmdKeyShortcut,
    getCmdAltKeyShortcut
};
